import n from "big.js";
import { wallet as o } from "../store/index.mjs";
import { ERROR_CONNECT_WALLET as i } from "./errors.mjs";
import { getPendingReward as c } from "./hodl_pool.mjs";
import { useHODLPoolRewarderContract as t } from "../store/hodlPoolRewarderContract.mjs";
function g() {
  return t().rewardDispatcher();
}
function p() {
  return t().rewardToken();
}
function u(e) {
  const r = o?.getAddress();
  if (r === void 0) throw i;
  return t().calculateWithdrawableReward(r, e);
}
function R(e, r) {
  return t().calculateTotalReward(e, r);
}
function d() {
  return t().percentageToVestingSchedule();
}
async function h(e) {
  const r = [
    c(e),
    d(),
    u(e)
  ];
  return await Promise.all(r).then((a) => n(a[0].toString()).div(100).times(100 - Number(a[1])).plus(a[2].toString()).toFixed());
}
export {
  R as calculateTotalReward,
  u as calculateWithdrawableReward,
  h as getHODLPoolRewardAmount,
  d as percentageToVestingSchedule,
  g as rewardDispatcher,
  p as rewardToken
};
//# sourceMappingURL=hodl_pool_rewarder.mjs.map
